import { useTheme } from "@/components/ThemeProvider";
import { Sun, Moon, Terminal } from "lucide-react";

export const Header = () => {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full glass-strong border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
          aria-label="Daniel Vassallo Apps - inicio"
        >
          <span className="w-8 h-8 grid place-items-center bg-foreground text-background font-mono font-bold text-sm group-hover:bg-[hsl(var(--accent-green))] group-hover:text-background transition-colors">
            DV
          </span>
          <span className="hidden sm:inline font-mono text-sm tracking-tight">
            <span className="text-muted-foreground">~/</span>
            <span className="font-bold">dvassalloapps</span>
            <span className="text-[hsl(var(--accent-green))] cursor-blink"></span>
          </span>
        </button>

        <nav className="flex items-center gap-1 sm:gap-2">
          <button
            data-testid="nav-apps"
            onClick={() => scrollTo("apps")}
            className="hidden sm:inline-flex font-mono text-xs uppercase tracking-[0.2em] px-3 py-2 hover:text-[hsl(var(--accent-green))] transition-colors"
          >
            Apps
          </button>
          <button
            data-testid="nav-about"
            onClick={() => scrollTo("about")}
            className="hidden sm:inline-flex font-mono text-xs uppercase tracking-[0.2em] px-3 py-2 hover:text-[hsl(var(--accent-cyan))] transition-colors"
          >
            About
          </button>
          <button
            data-testid="nav-contact"
            onClick={() => scrollTo("contact")}
            className="hidden sm:inline-flex font-mono text-xs uppercase tracking-[0.2em] px-3 py-2 hover:text-[hsl(var(--accent-magenta))] transition-colors"
          >
            Contact
          </button>

          <div className="w-px h-5 bg-border mx-1 hidden sm:block" />

          <button
            data-testid="theme-toggle"
            onClick={() => setTheme(isDark ? "light" : "dark")}
            aria-label="Alternar tema"
            className="w-10 h-10 grid place-items-center border border-border hover:border-[hsl(var(--accent-cyan))] hover:text-[hsl(var(--accent-cyan))] transition-colors"
          >
            {isDark ? <Sun size={16} strokeWidth={2} /> : <Moon size={16} strokeWidth={2} />}
          </button>

          <a
            data-testid="nav-terminal"
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("about");
            }}
            className="hidden md:inline-flex w-10 h-10 place-items-center border border-border hover:border-[hsl(var(--accent-green))] hover:text-[hsl(var(--accent-green))] transition-colors items-center justify-center"
            aria-label="About terminal"
          >
            <Terminal size={16} strokeWidth={2} />
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
